import { sendRequestAuto } from '@/utils/request'

export const saveAddressApi = (body: any) =>
  sendRequestAuto({ method: 'POST', url: '/address', body })

export const updateAddressApi = (id: string, body: any) =>
  sendRequestAuto({ method: 'PUT', url: `/address/${id}`, body })

export const setDefaultAddressApi = (id: string) =>
  sendRequestAuto({ method: 'POST', url: `/address/default/${id}` })

export const deleteAddressApi = (id: string) =>
  sendRequestAuto({ method: 'DELETE', url: `/address/${id}` })
